type ParseErknmValue = (
  value: string | null,
) =>
  | {
      title?: string;
      fullName?: string;
      nameNpa?: string;
      numberNpa?: string;
      questions?: { title: string }[];
      number?: number;
      shortTitle?: string | null;
      selectedLabel?: string;
    }
  | undefined;

export const parseErknmValue: ParseErknmValue = value => (value ? JSON.parse(value) : undefined);
